<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Выберите отчет для скачивания</h2>
    </div>
    <a-divider style="margin: 16px 0" />

    <div class="modal-no-padding__body">
      <div v-for="passing in passings" :key="passing.code" class="passing-list">
        <div v-if="passing.status === 'finished'" class="passing-card">
          <div>
            <div class="download-header date-header">
              <div class="grey-text">
                {{ passing.finished_at_formatted_ru_short }}
              </div>
              <div class="link-green">
                <PlusOutlined style="font-size: 10px" />
                <span @click="() => setActiveModal(passing)" class="new-report-types-button">
                  Получить другие
                </span>
              </div>
            </div>

            <div class="reports-list">
              <template v-if="passing.report_type === 'management'">
                <a-card class="report-card">
                  <div class="download-header">
                    <div>
                      {{ getReportName(passing.report_type) + ' Отчет для сотрудника'}}
                    </div>
                    <div v-if="!generatedReport || generatedReport !== passing.code"  @click="downloadReport(passing.code, 'employee')" class="download-icon">
                      <DownloadOutlined />
                    </div>
                    <div v-else>
                      <a-spin size="small" />
                    </div>
                  </div>
                </a-card>

                <a-card class="report-card">
                  <div class="download-header">
                    <div>
                      {{  getReportName(passing.report_type) + ' Отчет для заказчика'}}
                    </div>
                    <div v-if="!generatedReport || generatedReport !== passing.code"  @click="downloadReport(passing.code, 'employer')" class="download-icon">
                      <DownloadOutlined />
                    </div>
                    <div v-else>
                      <a-spin size="small" />
                    </div>
                  </div>
                </a-card>
              </template>

              <template v-else>
                <a-card class="report-card">
                  <div class="download-header">
                    <div>
                      {{  getReportName(passing.report_type) }}
                    </div>
                    <div v-if="!generatedReport || generatedReport !== passing.code"  @click="downloadReport(passing.code, passing.report_type)" class="download-icon">
                      <DownloadOutlined />
                    </div>
                    <div v-else>
                      <a-spin size="small" />
                    </div>
                  </div>
                </a-card>
              </template>

              <template v-for="differentReport in passing.related_passings" :key="differentReport.code">
                <template v-if="differentReport.report_type === 'management'">
                  <a-card class="report-card">
                    <div class="download-header">
                      <div>
                        {{ getReportName(differentReport.report_type) + ' Отчет для сотрудника'}}
                      </div>
                      <div v-if="!generatedReport || generatedReport !== differentReport.code"  @click="downloadReport(differentReport.code, 'employee')" class="download-icon">
                        <DownloadOutlined />
                      </div>
                      <div v-else>
                        <a-spin size="small" />
                      </div>
                    </div>
                  </a-card>

                  <a-card class="report-card">
                    <div class="download-header">
                      <div>
                        {{  getReportName(differentReport.report_type) + ' Отчет для заказчика'}}
                      </div>
                      <div v-if="!generatedReport || generatedReport !== differentReport.code"  @click="downloadReport(differentReport.code, 'employer')" class="download-icon">
                        <DownloadOutlined />
                      </div>
                      <div v-else>
                        <a-spin size="small" />
                      </div>
                    </div>
                  </a-card>
                </template>

                <template v-else>
                  <a-card class="report-card">
                    <div class="download-header">
                      <div>
                        {{  getReportName(differentReport.report_type) }}
                      </div>
                      <div v-if="!generatedReport || generatedReport !== differentReport.code" @click="downloadReport(differentReport.code, 'employer')" class="download-icon">
                        <DownloadOutlined />
                      </div>
                      <div v-else>
                        <a-spin size="small" />
                      </div>
                    </div>
                  </a-card>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!passings.length" class="spin">
        <p>Нет отчетов</p>
      </div>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-button class="secondary-button" @click="closeForm">Закрыть</a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>
<script>


import {useRouter} from "vue-router";
import {DownOutlined, PlusOutlined, DownloadOutlined} from "@ant-design/icons-vue";
import {computed} from "@vue/reactivity";
import {useStore} from "vuex";

import getReportName from "../../mixins/getReportName";
import {ref} from "@vue/runtime-core";
import {message} from "ant-design-vue";

export default {
  methods: {getReportName},
  components: {PlusOutlined, DownOutlined, DownloadOutlined},
  props: {
    open: Boolean,
    passings: Array,
  },
  emits: ['close', 'getAdditionalReports'],
  setup(props, context) {
    const router = useRouter();

    const columns = computed(() => [
      {
        title: 'Событие',
        dataIndex: 'name',
        sorter: false,
        width: 250,
      },
      {
        title: 'Статус',
        dataIndex: 'status',
        sorter: false,
        width: 90,
      },
      {
        title: 'Дата назначения',
        dataIndex: 'started_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Дата завершения',
        dataIndex: 'finished_at',
        sorter: false,
        width: 120,
      },
    ]);

    const store = useStore();

    const closeForm = () => {
      context.emit('close');
    }

    const setActiveModal = (passing) => {
      context.emit('getAdditionalReports', passing);
    }

    const generatedReport = ref(null);

    const downloadReport = (code, type) => {
      generatedReport.value = code;
      const generationMessageKey = `report-generation-${code}`;
      message.info({
        content: 'Идет генерация отчета, пожалуйста, подождите',
        duration: 0,
        key: generationMessageKey,
      });

      store.dispatch("group/getReport", {
        passing: [code],
        type: type,
      }).finally(() => {
        message.destroy(generationMessageKey);
        generatedReport.value = null;
      })
    };

    return {
      closeForm,
      router,
      columns,
      setActiveModal,
      generatedReport,
      downloadReport
    }
  }
}
</script>

<style scoped lang="scss">
.tests-list {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .secondary-button {
    margin-top: 16px;
  }
}

.test-details-card-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    justify-content: center;
  }
}

.test-title {
  font-weight: 600;
}

.test-image-wrapper img {
  width: 100px;
  max-height: 140px;
  object-fit: cover;
}

.action-buttons {
  justify-content: flex-end;
  display: flex;
  gap: 8px;

  @media(max-width: $mobile-breakpoint) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
}

.link-green {
  cursor: pointer;
  color: var(--main-green);
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.link-green:hover {
  color: var(--hover-green);
}

.download-header {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
}

:deep(.ant-card .ant-card-body) {
  padding: 5px !important;
}

.spin {
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  min-height: 20vh;
}

h2 {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
}

.date-header {
  margin-bottom: 12px;
}

.reports-list {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
}

.report-card {
  padding: 12px 16px;

  :deep(.ant-card .ant-card-body) {
    padding: 0 !important;
  }
}

.passing-card {
  margin-bottom: 16px;
}

.download-icon {
  cursor: pointer;
  color: var(--main-green);

  &:hover {
    color: var(--hover-green)
  }
}

</style>
